import {config} from '@config';
import schema from '@linx-security/api-specs/schema.json';
import {FileFormat} from '@linx-security/api-specs';
import {HTTPMethod} from '@linx-security/api';

const encodeParam = (str: string) => encodeURIComponent(String(str));

const {paths} = schema;

const {
  api: {prefix: BASE_URL},
} = config;

export const routes = {
  baseURL: BASE_URL,
  // Used only for mocking
  knowledge: {
    lifecycle: {
      get: {path: `/mock/knowledge-service/lifecycle`, method: HTTPMethod.GET},
    },
    permissions: {
      get: {path: `/mock/knowledge-service/permissions`, method: HTTPMethod.GET},
    },
  },
  user: {
    events: {
      get: {path: `/mock/user-service/users/events`, method: HTTPMethod.GET},
    },
  },
  accessAnalysis: {
    groups: {
      get: {
        path: `/mock/access-analysis-service/group_access/{groupId}`,
        method: HTTPMethod.GET,
      },
    },
    apps: {
      get: {
        path: `/mock/access-analysis-service/app_access/{appId}`,
        method: HTTPMethod.GET,
      },
    },
  },
  resources: {
    get: {
      path: `/mock/api-service/resources`,
      method: HTTPMethod.GET,
    },
    getOne: {
      path: (id: string) => `/mock/api-service/resources/${encodeParam(id)}`,
      method: HTTPMethod.GET,
    },
    export: {
      path: `/api-service/resources/$/export`,
      method: HTTPMethod.GET,
    },
  },
  groups: {
    members: {
      export: {
        path: ({id}: {id: string}) => {
          return `/user-service/groups/${encodeParam(id)}/members/$/export`;
        },
      },
    },
    export: `/user-service/groups/$/export`,
    byUserId: ({userId}: {userId: string}) => ({
      export: {
        path: `/user-service/canonical_users/{canonical_user_id}/groups/$/export`.replace(
          `{${`canonical_user_id`}}`,
          userId,
        ),
      },
    }),
    byAppId: ({appId}: {appId: string}) => ({
      export: {
        path: `/user-service/groups/{group_arango_key}/idp_applications/$/export`.replace(
          `{${`group_arango_key`}}`,
          appId,
        ),
      },
    }),
  },
  // User Access Review
  reviews: {
    export: `/uar-service/reviews/$/export`,
  },
  campaigns: {
    report: ({campaignId, fileFormat = FileFormat.Xlsx}: {campaignId: string; fileFormat?: FileFormat}) =>
      `/uar-service/campaigns/${campaignId}/report?format=${fileFormat}`,
    audits: ({campaignId}: {campaignId: string}) => `/uar-service/campaigns/${campaignId}/audits`,
  },
  // Accounts
  accounts: {
    export: `/api-service/accounts/$/export`,
    byUserId: ({userId}: {userId: string}) => ({
      export: {
        path: `/user-service/canonical_users/{canonical_user_id}/accounts/$/export`.replace(
          `{${`canonical_user_id`}}`,
          userId,
        ),
      },
    }),
  },
  roles: {
    byAppId: ({appId}: {appId: string}) => ({
      export: {
        path: `/user-service/idp_applications/{idp_application_arango_key}/idp_application_roles/$/export`.replace(
          `{${`idp_application_arango_key`}}`,
          appId,
        ),
      },
    }),
  },
  // Users (Soon to be Human)
  users: {
    export: `/user-service/canonical_users/$/export`,
  },
  apps: {
    export: `/user-service/idp_applications/$/export`,
  },
  // AI Assistant
  aiAssistant: {
    exportTurnTable: ({sessionId, turnId}: {sessionId: string; turnId: string}) =>
      `${BASE_URL}/ai-assistant-service/sessions/${encodeParam(sessionId)}/turns/${encodeParam(turnId)}/export`,
    exportGovernanceAction: ({sessionId, turnId, previewId}: {sessionId: string; turnId: string; previewId: string}) =>
      `${BASE_URL}/ai-assistant-service/sessions/${encodeParam(sessionId)}/turns/${encodeParam(turnId)}/governance-actions/${encodeParam(previewId)}/export`,
  },
};

/**
 * @description This function in the code to demonstrate utilizing the API Spec directly in the codebase.
 */
export const isValidPath = (path: string) => Object.keys(paths).includes(path);
